const prodConfig = {
  CLIENT_HOST: 'league-live.sunrun.com',
  MIXPANEL_KEY: '3ac1e7a198a9eeaa18d1847405a2549a',
};

export default prodConfig;
